import React from 'react';

const LiasseFiscale = () => {
  return (
    <div className="bilan-comptable">
      <h2>Bilan Comptable</h2>
      {/* Ajoute ton contenu ici */}
    </div>
  );
};

export default LiasseFiscale;